export const lang = 'de';
